import React from 'react'

import OmniValue from '@cinch/oxd-components/omni-value/src'
import { Fields } from '@cinch/oxd-components/your-money/src'
import { currencyValueFormatter } from '@cinch/oxd-utils/form/src'
import { FormRenderProps } from 'react-final-form'

const BudgetFields: React.FC<{ i18n: Cinch.WebAppTranslations['lifestyle']['budget'] } & FormRenderProps> = ({
  i18n,
  form,
}) => {
  const [budget, setBudget] = React.useState(form.getFieldState('budget'))

  React.useEffect(() => {
    const unSubscribe = form.subscribe((formState) => setBudget(formState.values.budget), { values: true })

    return () => unSubscribe()
  })

  return (
    <>
      <OmniValue value={currencyValueFormatter(budget)} label={i18n.budgetLabel} />
      <Fields i18n={i18n} />
    </>
  )
}

export default BudgetFields
